import { render, staticRenderFns } from "./AboutIt.vue?vue&type=template&id=6d254d70&scoped=true"
import script from "./AboutIt.vue?vue&type=script&lang=js"
export * from "./AboutIt.vue?vue&type=script&lang=js"
import style0 from "./AboutIt.vue?vue&type=style&index=0&id=6d254d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d254d70",
  null
  
)

export default component.exports